import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/payment-announcements', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/payment-announcements', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/payment-announcements/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/payment-announcements/${data.anc_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/payment-announcements/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getMainProgram = (Options = {}) => {
  return httpClient
    .get('/api/payment-announcements/main-programs')
    .then(response => Promise.resolve(response.data))
}

export const getSubProgram = acp_id => {
  return httpClient
    .get(`/api/payment-announcements/sub-programs/${acp_id}`)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getMainProgram,
  getSubProgram
}
